export default class mobileMenu {
  constructor() {
    this.body           = document.querySelector('body');
    this.toggle         = document.querySelector('.js-hamburger');
    this.menu           = document.querySelector('.js-navigation');
    this.header         = document.querySelector('.js-header');

    if (this.toggle && this.menu) {
      this.submenuToggles = this.menu.querySelectorAll('.js-submenu-parent-link');
      this.submenus       = this.menu.querySelectorAll('.js-submenu');
      this.ui             = this.menu.querySelector('.js-navigation-ui-text');
      this.back           = this.menu.querySelector('.js-navigation-back');
      this.searchTrigger  = document.querySelector('.js-mobile-search-trigger');

      this.copyNodes();

      if (this.toggle && this.menu) {
        this.toggle.addEventListener('click', (event) => {
          this.toggleMenu();
        });
      }

      if (this.submenuToggles  && this.submenus) {
        this.watchSubmenus();
      }

      if (this.searchTrigger) {
        this.watchSearchTrigger();
      }
    }
  }

  toggleMenu() {
    if (this.toggle.classList.contains('m-hamburger--toggled')) {
      this.toggle.classList.remove('m-hamburger--toggled');
      this.menu.classList.remove('is-active');
      this.header.classList.remove('mobile-menu-active')

      this.body.classList.remove('mobile-menu-active');
      this.unlockScroll()

      setTimeout(() => {
        this.closeMenu();
      }, 200);
    } else {
      this.toggle.classList.add('m-hamburger--toggled');
      this.menu.classList.add('is-active');
      this.header.classList.add('mobile-menu-active');

      this.body.classList.add('mobile-menu-active');
      this.lockScroll()

      console.log('Toggling closed');
    }
  }

  watchSubmenus() {
    this.submenuToggles.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const linkText = link.text;
        const submenu = link.parentElement.querySelector('.js-submenu');

        this.changeUi(linkText);
        this.openSubmenu(submenu);

        return false;
      })
    });

    this.back.addEventListener('click', (event) => {
      event. preventDefault();

      this.menu.classList.remove('is-toggled');

      return false;
    })
  }

  watchSearchTrigger() {
    this.searchTrigger.addEventListener('click', e => {
      this.toggle.classList.remove('is-active');
      this.menu.classList.remove('is-active');
    })
  }

  changeUi(text) {
    this.ui.innerText = text;
  }

  openSubmenu(submenu) {
    this.menu.classList.add('is-toggled');
    this.closeSubmenus();
    submenu.classList.add('is-active');
  }

  closeMenu() {
    this.menu.classList.remove('is-toggled');
    this.closeSubmenus();
  }

  closeSubmenus() {
    this.submenus.forEach((submenu) => {
      submenu.classList.remove('is-active');
    });
  }

  copyNodes() {
    this.submenus.forEach(sub => {
      const parent = sub.closest('.js-submenu-parent');
      const parentLink = parent?.querySelector('.js-submenu-parent-link');

      if(!!parentLink) {
        const clone = parentLink.cloneNode(true);
        const listItem = document.createElement('li');
        listItem.classList.add(
          'menu-item',
          'm-mobile-navigation__item',
          'm-mobile-navigation__item--clone'
        );

        clone.classList.remove(
          'm-mobile-navigation__link--has-submenu',
          'js-submenu-parent-link'
        );

        listItem.append(clone);
        sub.prepend(listItem);
      }
    })
  }

  lockScroll() {
    this.scrollY = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.width = '100%';
  }

  unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    window.scrollTo(0, this.scrollY || 0);
    window.dispatchEvent(new Event('scroll'));
  }
}
